/** Read-only Step6 view of the server-produced keyword policy contract. */
export function createRevisionKeywordPolicy({ getState }) {
  function getPolicies() {
    return getState('keywordUsePolicies')
      || getState('businessContext')?.keywordUsePolicies
      || getState('listingGenerationMeta')?.mergeMeta?.businessMeta?.keywordUsePolicies
      || [];
  }

  function find(keyword) {
    const normalized = String(keyword || '').toLowerCase().trim();
    if (!normalized) return null;
    const policies = getPolicies();
    if (!Array.isArray(policies)) return null;
    return policies.find((item) => String(item?.keyword || item?.normalizedKeyword || '').toLowerCase().trim() === normalized) || null;
  }

  function isAllowedForSearchTerms(keyword) {
    const policy = find(keyword);
    return !policy || (policy.policy !== 'forbidden' && !(Array.isArray(policy.blockedFields) && policy.blockedFields.includes('searchTerms')));
  }

  return { getPolicies, find, isAllowedForSearchTerms };
}
